var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1139,
    height: 228,
    viewBox: "0 0 1139 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7261_31585)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.244,
    cy: 300.992,
    rx: 385.244,
    ry: 300.992,
    transform: "matrix(0.998419 0.0562106 -0.989613 0.143761 365.722 -145.863)",
    fill: "#FFE6C1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7261_31585)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.1762,
    cy: 232.898,
    rx: 91.1762,
    ry: 232.898,
    transform: "matrix(-0.457584 0.889166 0.991984 -0.126361 -73.0195 -110.148)",
    fill: "#FF9900"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7261_31585)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.103,
    cy: 229.059,
    rx: 239.103,
    ry: 229.059,
    transform: "matrix(0.982447 0.186544 -0.999243 0.0389066 353.937 -144.814)",
    fill: "#FFAE34"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7261_31585",
    x: -234.017,
    y: -329.335,
    width: 1373.02,
    height: 496.795,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_7261_31585"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7261_31585",
    x: -318.518,
    y: -344.777,
    width: 869.617,
    height: 572.541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_7261_31585"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7261_31585",
    x: -168.021,
    y: -336.793,
    width: 1055.96,
    height: 490.987,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_7261_31585"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.211e3d1c159a1d5e4322672f78d0f667.svg";
export { ForwardRef as ReactComponent };